import React from 'react';
import styled from 'styled-components';
import { Menu as AntdMenu } from 'antd';
import { MenuProps } from 'antd/lib/menu';
import theme from '../theme';

import MenuItem from './MenuItem';

export const MenuDivider = styled(AntdMenu.Divider)`
  width: 90%;
  margin-left: auto;
  margin-right: auto;
`;

export { MenuItem };

export const MenuSubMenu = styled(AntdMenu.SubMenu)``;

export const MenuItemGroup = styled(AntdMenu.ItemGroup)``;

export { MenuProps };

// This wrapper is used to block access to Menu.Item and others subcomponents
export const Menu = styled<React.FC<MenuProps>>(props => (
  <AntdMenu {...props} />
))`
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  && {
    box-shadow: ${theme.getElevation()};
    border-radius: ${theme.getBorderRadius('large')};
    padding: 10px;
  }
`;
